import React from 'react';
import PropTypes from 'prop-types';

class TwitchEmbed extends React.Component {
    static get propTypes() {
        return {
            userName: PropTypes.string,
        };
    }

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <iframe
                src={`https://player.twitch.tv/?channel=${this.props.userName}&muted=true&parent=${window.location.hostname}`}
                frameBorder="0"
                scrolling="no"
                allowFullScreen={true}>
            </iframe>
        );
    }
}

export default TwitchEmbed;